class MaterialesRecepcionDetalles {
    constructor({ id, fk_materiales_recepcion, fk_material, coste, cantidad,
                  unidades_esperadas, unidades_recibidas, unidades_procesadas,
                  fk_material_sustituto, unidades_sustituto, unidades_sustituto_procesadas } = {}) {
        this.id = id
        this.fk_material = fk_material
        this.fk_materiales_recepcion = fk_materiales_recepcion
        this.coste = coste
        this.cantidad = cantidad
        this.unidades_esperadas = unidades_esperadas ?? 0
        this.unidades_recibidas = unidades_recibidas ?? 0
        this.unidades_procesadas = unidades_procesadas ?? 0
        this.fk_material_sustituto = fk_material_sustituto ?? null
        this.unidades_sustituto = unidades_sustituto ?? 0
        this.unidades_sustituto_procesadas = unidades_sustituto_procesadas ?? 0
    }
}

export default MaterialesRecepcionDetalles